"use strict";

import angular from "angular";

class AutopilotReportsDialogCtrl {
    switchShared = true;

    constructor($mdDialog, locals, DSNDialogService) {
        this.$mdDialog = $mdDialog;
        this.locals = locals;
        this.DSNDialogService = DSNDialogService;
    }

    $onInit() {}

    onActive() {
        this.$mdDialog.hide({ shared: this.switchShared });
    }
}
angular.module("nucont.shared").controller("AutopilotReportsDialogCtrl", [
        "$mdDialog",
        "locals",
        "DSNDialogService",
        AutopilotReportsDialogCtrl
    ]);
